import { types } from "mobx-state-tree";

export const loadingStatus = types.enumeration([
  "idle",
  "loading",
  "success",
  "error",
]);
